import Box from 'shared_DEPRECATED/components/Box';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { zIndexes } from 'shared/config/zIndexes';

export const FixedArea = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: zIndexes.fixedArea,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
      }}
    >
      <Spacer size="zr md">
        <Flex
          flexDirection="row-reverse"
          alignItems="end"
          justifyContent="end"
          gap="0.5rem"
        >
          {children}
        </Flex>
      </Spacer>
    </Box>
  );
};
